/* eslint-disable react-refresh/only-export-components */
import React from 'react'
import {
    Outlet,
    RouteObject,
    useOutletContext,
    useSearchParams,
} from 'react-router-dom'
import { Cliente, clientes as clientesApi } from 'service/api'
import { PaginatedResponse } from 'service/api/types'
import AdminAlterarSenha from 'templates/Admin/Clientes/atoms/AlterarSenha'
import FuncionariosEmpresaCliente from 'templates/Admin/Clientes/atoms/FuncionariosEmpresas'
import AdicionarClientes from 'templates/Admin/Clientes/modals/Adicionar'
import DetalhesRegistroReadOnly from 'templates/Admin/Clientes/modals/DetalhesRegistroLeitura'
import EditarCliente from 'templates/Admin/Clientes/modals/Editar'
import FinanceiroCliente from 'templates/Admin/Clientes/modals/Financeiro'
import DetalhesEmpresa from 'templates/Cadastro/Empresas/modals/Detalhes'
import DetalhesFuncionario from 'templates/Cadastro/Funcionarios/organismos/modals/Detalhes'

const Clientes = React.lazy(() => import('pages/Clientes'))
const ParametrosFinanceiros = React.lazy(
    () => import('pages/ParametrosFinanceiros'),
)
const EmpresasClientePage = React.lazy(
    () => import('templates/Admin/Clientes/atoms/Empresas'),
)

const RegistrosEmpresaCliente = React.lazy(
    () => import('templates/Admin/Clientes/atoms/RegsitrosEmpresas'),
)

const UsuariosClientePage = React.lazy(
    () => import('templates/Admin/Clientes/atoms/Usuarios'),
)

const LogsPage = React.lazy(() => import('pages/Logs'))

const ModulosClientePage = React.lazy(
    () => import('templates/Admin/Clientes/atoms/Modulo'),
)

const base = '/administracao'
const clientes = '/clientes'
const clienteId = '/clientes/:id'
const empresas = '/empresas'
const usuarios = '/usuarios'
const empresaId = '/empresas/:empresaId'
const registros = '/registros'
const registroIdDetalhes = '/registros/:registroId/detalhes'
const funcionarios = '/funcionarios'
const funcionarioIdDetalhes = '/funcionarios/:funcionarioId/detalhes'

const AdminPreloader = () => {
    const [searchParams] = useSearchParams()
    const filter = searchParams.get('filter')

    const { data } = clientesApi.useFetch<PaginatedResponse<Cliente>>({
        queryParams: filter ? { filter } : undefined,
        enabled: true,
        keepPreviousData: false,
    })

    return <Outlet context={{ clientes: data?.data }} />
}

export function useAdminOutletContext() {
    return useOutletContext<{ clientes?: Cliente[] }>()
}

export const admin: RouteObject = {
    path: base,
    element: <AdminPreloader />,
    children: [
        {
            // url: /administracao/clientes
            path: base + clientes,
            element: <Clientes />,
            children: [
                {
                    path: base + clientes + '/adicionar',
                    element: <AdicionarClientes />,
                },
                {
                    path: base + clienteId + '/editar',
                    element: <EditarCliente />,
                },
                {
                    path: base + clienteId + '/financeiro',
                    element: <FinanceiroCliente />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/usuarios
            path: base + clienteId + usuarios,
            element: <UsuariosClientePage />,
            children: [
                {
                    path: base + clienteId + usuarios + '/:id/alterar-senha',
                    element: <AdminAlterarSenha />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/modulos
            path: base + clienteId + '/modulos',
            element: <ModulosClientePage />,
        },
        {
            // url: /administracao/clientes/:id/empresas
            path: base + clienteId + empresas,
            element: <EmpresasClientePage />,
            children: [
                {
                    path: base + clienteId + empresaId + '/detalhes',
                    element: <DetalhesEmpresa />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/empresas/:empresaId/registros
            path: base + clienteId + empresaId + registros,
            element: <RegistrosEmpresaCliente />,
            children: [
                {
                    path: base + clienteId + empresaId + registroIdDetalhes,
                    element: <DetalhesRegistroReadOnly />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:id/empresas/:empresaId/funcionarios
            path: base + clienteId + empresaId + funcionarios,
            element: <FuncionariosEmpresaCliente />,
            children: [
                {
                    path: base + clienteId + empresaId + funcionarioIdDetalhes,
                    element: <DetalhesFuncionario />,
                },
            ],
        },
        {
            path: base + '/logs',
            element: <LogsPage />,
        },
        {
            path: base + '/parametros-financeiros',
            element: <ParametrosFinanceiros />,
        },
    ],
}
